/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class QueryService2API
 * @hideconstructor
 * @classdesc API class that is used to support the creation of QueryAPI2
 */
define([], () => {
	class QueryService2API {

		/**
		 * @public
		 * @readonly
		 * @description Enumeration of Query type
		 * @enum {String}
		 * @memberof QueryServiceAPI
		 */
		static get TYPE() {
			return {
				/** default */
				DEFAULT: undefined,
				/** min / max query */
				MINMAX: 'minmax',
				/** unaggregated detail query */
				DETAIL: 'detail'
			};
		}

		/**
		 * @function QueryServiceAPI#registerQueryClass
		 * @description Register a Class which implements QueryAPI2
		 * @public
		 *
		 * @param {String} queryProtocol - the protocol of query
		 * @param {Class} QueryClass - a Class which implements QueryAPI2
		 */
		registerQueryClass() {}

		/**
		 * @function QueryServiceAPI#createQueryDefinition
		 * @description Creates and returns a QueryDefinitionAPI object to construct queries
		 * @public
		 *
		 * @param {String} id
		 * @param {String} type
		 * @return {QueryServiceAPI}
		 */
		createQueryDefinition() {}

		/**
		 * @function QueryServiceAPI#createQueryV2
		 * @description Creates and returns a QueryAPI2 object to run queries
		 * @public
		 *
		 * @param {QueryDefinitionAPI} definition The QueryDefinition to use in the Query
		 * @param {String} queryProtocol The protocol to create
		 * @return {Query2API} Returns a Query2API object
		 */
		createQuery() {}

	}

	return QueryService2API;
});
